import Link from 'next/link';
import Image from 'next/image';
import { ReactNode } from 'react';

type IDestinationCardProps = {
  allowanceInfo: ReactNode;
  promoText: ReactNode;
  flagName: string;
  name: string;
  url: string;
  allowance: string;
  allowancePromo: string | null;
  hasPromo: boolean;
  onClick: () => void;
};

export const DestinationCard = ({
  allowanceInfo,
  promoText,
  flagName,
  name,
  url,
  allowance,
  allowancePromo,
  hasPromo,
  onClick,
}: IDestinationCardProps) => {
  return (
    <Link
      href={url}
      onClick={() => {
        window.dataLayer?.push({
          event: 'click_button',
          click_id: url,
          click_label: name,
        });
        onClick();
      }}
      className={
        'flex items-center justify-between rounded-lg bg-neutral-100 p-6 text-black no-underline hover:bg-neutral-200 active:bg-neutral-300'
      }
    >
      <div className={'flex max-w-[calc(100%-55px)] items-center gap-1'}>
        <div className={'relative'}>
          <Image
            src={`/static/flags/${flagName}`}
            alt={name}
            width={32}
            height={32}
          />
          {hasPromo && (
            <div
              className={
                'absolute right-1/2 top-[-10px] translate-x-1/2 rounded-4xl bg-primary px-1 py-0.5 text-xs font-bold uppercase text-white'
              }
            >
              {promoText}
            </div>
          )}
        </div>
        <p className={'truncate text-xl font-semibold'}>{name}</p>
      </div>
      <div className={'flex items-center gap-2.5'}>
        <div className={'flex items-end gap-2 leading-none'}>
          {hasPromo && <p className={'text-gray line-through'}>{allowance}</p>}
          <div>
            <div className={'text-end text-xs'}>{allowanceInfo}</div>
            <p className={'text-xl font-semibold leading-none'}>
              {allowancePromo}
            </p>
          </div>
        </div>
        <Image
          src={'/static/icons/chevron-right.svg'}
          alt={'Chevron'}
          width={7.33}
          height={12.67}
        />
      </div>
    </Link>
  );
};
